import React, { useCallback } from 'react';
import { Button, CompositeTextInput } from '@leverege/ui-elements';
import S from './DeviceInput.css';
import { jsx as _jsx } from "react/jsx-runtime";
export default function DeviceInput(props) {
  const {
    value,
    eventData,
    onFocus: pOnFocus,
    onClick,
    hint,
    scanEnabled = true,
    'data-test-postfix': testId,
    error
  } = props;
  const onFocus = useCallback(() => {
    pOnFocus({
      data: {
        screen: 'search',
        field: eventData
      },
      value
    });
  }, [pOnFocus]);
  const imageOpts = {
    style: {
      width: '16px',
      height: '16px'
    }
  };
  return /*#__PURE__*/_jsx("div", {
    className: S.inputContainer,
    children: /*#__PURE__*/_jsx(CompositeTextInput, {
      "data-test-id": `input.pairing.search${testId}`,
      variant: "scan",
      icon: value ? error ? 'https://recovr-ui-assets.storage.googleapis.com/icon-system-error-2x.png' : 'https://recovr-ui-assets.storage.googleapis.com/success.png' : 'https://recovr-ui-assets.storage.googleapis.com/search.png',
      imageOpts: imageOpts,
      post: scanEnabled ? /*#__PURE__*/_jsx(Button, {
        "data-test-id": `button.pairing.scan${testId}`,
        className: S.cameraIcon,
        icon: "https://recovr-ui-assets.storage.googleapis.com/camera.png",
        imageOpts: imageOpts,
        onClick: onClick,
        eventData: {
          screen: 'scan',
          field: eventData
        },
        variant: "pairCamera|tertiarySmallIconic"
      }) : null,
      hint: hint,
      value: value,
      eventData: {
        screen: 'search',
        field: eventData
      },
      onFocus: onFocus
    })
  });
}